const ForbiddenIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={220}
      height={220}
      viewBox="0 0 220 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="110" cy="110" r="110" fill="white" />
      <path
        d="M110.003 117.87C130.581 117.871 148.85 127.851 160.446 143.256C161.487 144.638 162.627 146.137 163.431 147.578C164.356 149.234 165.04 151.153 164.998 153.483C164.964 155.358 164.399 157.117 163.712 158.502C163.025 159.887 161.972 161.396 160.504 162.552C158.545 164.096 156.412 164.64 154.517 164.869C152.779 165.078 150.704 165.07 148.633 165.07H71.3667C69.2974 165.07 67.2255 165.078 65.4889 164.869C63.5942 164.641 61.461 164.095 59.502 162.552C58.0338 161.396 56.9803 159.887 56.2933 158.502C55.6064 157.117 55.036 155.358 55.0018 153.483C54.9599 151.153 55.6444 149.234 56.5689 147.578C57.3734 146.136 58.5188 144.639 59.5594 143.256C71.1562 127.852 89.4246 117.87 110.003 117.87ZM142.331 79.5203C142.331 97.4416 127.857 111.97 110.003 111.97C92.1487 111.97 77.675 97.4419 77.675 79.5203C77.675 61.5987 92.1487 47.0703 110.003 47.0703C127.857 47.0708 142.331 61.599 142.331 79.5203Z"
        fill="#03152F"
      />
      <path
        d="M200 110C200 60.2944 159.706 20 110 20C88.7498 20 69.2249 27.3712 53.8281 39.6875L180.303 166.162C192.618 150.766 200 131.25 200 110ZM20 110C20 159.706 60.2944 200 110 200C131.25 200 150.766 192.618 166.162 180.303L39.6875 53.8281C27.3712 69.2249 20 88.7498 20 110ZM220 110C220 170.751 170.751 220 110 220C49.2487 220 0 170.751 0 110C0 49.2487 49.2487 0 110 0C170.751 0 220 49.2487 220 110Z"
        fill="#D6336C"
      />
    </svg>
  );
};

export default ForbiddenIcon;
